import styled from 'styled-components';

export const ParameterArea = styled.div`
    width: 100%;
    border: 1px solid #ddd;
    padding: 10px;
    padding-right: 0px;
`;
